/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../../extendIcon';

const ArrowDown = props => (
  <svg viewBox="0 0 9.092 5.443" width="1em" height="1em" {...props}>
    <path
      d="M8.968 1.368a.424.424 0 00-.003-.622L8.311.128a.472.472 0 00-.65.002L4.578 3.138 1.444.131a.477.477 0 00-.651.002l-.65.624a.427.427 0 00.003.622L4.26 5.317c.181.17.473.169.651-.003l4.057-3.946z"
      fill="#5d6164"
    />
  </svg>
);
export default extendIcon(ArrowDown);
